export default __webpack_public_path__ + "static/media/portfolio-42-small.a225a66f.jpg";